import "./BuildingExcellence.module.css";
import Navigation from "@/reusable_sections/Header";
import Philosophy from "./sections/Philosophy";
import Construction from "./sections/Construction";
import TheConstructionProcess from "./sections/TheConstructionProcess";
import Footer from "@/reusable_sections/Footer";
export default function BuildingExcellencePage() {
  return <div>
      <Navigation />
      <Philosophy />
      <Construction />
      <TheConstructionProcess />
      <Footer />
    </div>;
}